import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "featureId", "featureCategoryId", "onClick", "tooltip", "usageTracker"];
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { AIBaseLoadingButton } from './internal/AIBaseLoadingButton';
import { cloneTracker } from '../../utils/UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
const AILoadingButton = _ref => {
  let {
      children,
      featureId,
      featureCategoryId,
      onClick,
      tooltip,
      usageTracker
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const aiTracker = cloneTracker(usageTracker);
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      aiTracker.track('aiButtonInteraction', {
        type: 'trigger',
        featureId,
        featureCategoryId
      });
    }
  };
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip,
    children: /*#__PURE__*/_jsx(AIBaseLoadingButton, Object.assign({}, props, {
      "data-test-id": "ai-loading-button",
      onClick: handleClick,
      children: children
    }))
  });
};
export default AILoadingButton;